const WEB_SERVICES_MODULE_PROVIDERS = [];

export {WEB_SERVICES_MODULE_PROVIDERS};
